import { useEffect, useState } from "react";
import { IconUsers } from "@tabler/icons-react";
import { clientTeamGetUsers } from "../../../../services/clientCalls";
import { getNameInitials } from "../../../../utils/functions";
import styles from "../../../../pages/ClientDashboard/Profile/profile.module.css";

const AVATAR_COLORS = ["var(--navy)", "#1d4ed8", "#10b981", "#d97706", "#7c3aed"];

export default function TeamMembersCard() {
  const [members, setMembers] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const loadMembers = async () => {
      try {
        const res = await clientTeamGetUsers({ page: 1, limit: 100 });
        const users =
          res?.data?.data?.users ||
          res?.data?.data?.records ||
          res?.data?.data ||
          [];
        setMembers(Array.isArray(users) ? users : []);
      } catch (_) {
        setMembers([]);
      } finally {
        setLoaded(true);
      }
    };
    loadMembers();
  }, []);

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLeft}>
          <div className={styles.cardIcon}>
            <IconUsers size={18} />
          </div>
          <div>
            <div className={styles.cardTitle}>Team Members</div>
          </div>
        </div>
      </div>
      <div className={styles.cardBody}>
        {loaded && members.length === 0 && (
          <p
            style={{ fontSize: 13, color: "var(--text-muted)", marginBottom: 14 }}
          >
            No team members yet. Invite people from Team Management.
          </p>
        )}
        <div className={styles.memberList}>
          {members.map((m, index) => {
            const name =
              `${m.firstName || ""} ${m.lastName || ""}`.trim() || m.email;
            return (
              <div key={m._id || m.id || m.email} className={styles.memberRow}>
                <div
                  className={styles.memberAvatar}
                  style={{ background: AVATAR_COLORS[index % AVATAR_COLORS.length] }}
                >
                  {getNameInitials(m.firstName, m.lastName) ||
                    String(m.email || "?").charAt(0).toUpperCase()}
                </div>
                <div>
                  <div className={styles.memberName}>{name}</div>
                  <div className={styles.memberRole}>
                    {[m.role, m.status].filter(Boolean).join(" · ")}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
